import React from 'react';
import { NotificationsProvider } from './notifications';

export function RootProvider({ children }: { children: React.ReactNode }) {
  return <NotificationsProvider>{children}</NotificationsProvider>;
}
